import React, { useState } from 'react';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { classNames, isEnumValid, isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ImagePhoto } from '../../../../resources/assets/components/DLS_ImagePhoto.svg';
import { CardContainer } from '../../card-container/container/card-container.js';
import { Checkbox } from '../../checkbox/checkbox.js';
import { GalleryType } from '../../gallery/gallery-constants.js';
import { InlineImage } from '../../inline-image/inline-image.js';
import MediaContainer from '../../media-container/media-container.js';
import { GalleryFooter } from '../footer/gallery-footer.js';
import { GalleryHover } from '../hover/gallery-hover.js';
import './gallery-card.css';
function Photo(props) {
    if (props.image) {
        return React.createElement(InlineImage, { className: "c-gallery-card__body--image", src: props.image });
    }
    return React.createElement(ImagePhoto, { className: "c-gallery-card__body--svg" });
}
function GalleryHoverElement(props) {
    if (!props.isHovering || !(props.image || isFunction(props.onDelete))) {
        return null;
    }
    return React.createElement(GalleryHover, { ...props, onDetailsClick: () => props.setMediaContainerVisible(true), onMouseLeave: () => props.handleMouse(false) });
}
function MediaContainerElement(props) {
    if (!props.isMediaContainerVisible) {
        return null;
    }
    return (React.createElement(MediaContainer, { data: [{ name: props.name, src: props.image ?? '' }], deleteOptionEnabled: false, downloadOptionEnabled: false, initialOpen: true, onClose: () => props.setMediaContainerVisible(false), printOptionEnabled: false }));
}
function GalleryCard(props) {
    const [isHovering, setIsHovering] = useState(false);
    const [isMediaContainerVisible, setMediaContainerVisible] = useState(false);
    const handleMouse = (value) => {
        if (props.type === GalleryType.HOVER_CONTENT) {
            setIsHovering(value);
        }
    };
    const className = classNames({
        'c-gallery-card': true,
        [`c-gallery-card--${props.type}`]: isEnumValid(GalleryType, props.type),
    });
    return (React.createElement(CardContainer, { className: className, onSelect: props.onSelect, selectable: props.selectable, selected: Boolean(props.selected), selectionType: SelectionType.MULTIPLE },
        props.selectable ? (React.createElement(Checkbox, { className: "c-gallery-card__body--checkbox", name: `gallery-card-checkbox-${props.id}`, onChange: props.onSelect, value: props.selected })) : null,
        React.createElement("div", { className: "c-gallery-card__body", onMouseEnter: () => handleMouse(true), tabIndex: 0 },
            React.createElement(Photo, { image: props.image })),
        React.createElement(GalleryFooter, { ...props, onDetailsClick: () => setMediaContainerVisible(true) }),
        React.createElement(GalleryHoverElement, { ...props, handleMouse: handleMouse, isHovering: isHovering, setMediaContainerVisible: setMediaContainerVisible }),
        React.createElement(MediaContainerElement, { image: props.image, isMediaContainerVisible: isMediaContainerVisible, name: props.name, setMediaContainerVisible: setMediaContainerVisible })));
}
export { GalleryCard, };
//# sourceMappingURL=gallery-card.js.map